import React from 'react';
import { RawAgeDisplayerProps } from '@components/result/age-antispoofing/age-displayer/raw-age-displayer/RawAgeDisplayer';
import styles from '@components/result/age-antispoofing/ageAntispoofingResponse.module.scss';

export type Interval = 1 | 2 | 3 | 4;

export interface RangeAgeDisplayerProps extends RawAgeDisplayerProps {
    interval: Interval;
}

export const RangeAgeDisplayer: React.FC<RangeAgeDisplayerProps> = ({ age, interval }) => {
    const roundedAge = Math.round(age);
    const formattedAge = `(${roundedAge - interval} - ${roundedAge + interval})`;
    return (
        <span data-qa="age-result" className={styles['response__text']}>
            {formattedAge}
        </span>
    );
};
